import { useMutation, UseMutationOptions, UseMutationResult, useQueryClient } from "@tanstack/react-query";

import { contactService } from "../../services/crm/contactService";

import { Contact } from "../../interfaces/DTO/crm/contact";
import { CacheManager } from "../cacheManager";
import { ShareContactResponse, SharedContactDTO } from "../../interfaces/DTO/features/ShareContact";
import { shareService } from "../../services/features/ShareService";

export const useShareContactMutation = (
    options?: UseMutationOptions<ShareContactResponse, Error, SharedContactDTO>
  ): UseMutationResult<ShareContactResponse, Error, SharedContactDTO> => {
    const queryClient = useQueryClient();
    const cacheManager = CacheManager.getInstance(queryClient);
  
    return useMutation<ShareContactResponse, Error, SharedContactDTO>({
      mutationFn: (payload) => shareService.shareContact(payload),
      onSuccess: async (result, variables, context) => {
        if (result.new_contact_id) {
          // invalidate כל אנשי הקשר
          await queryClient.invalidateQueries({ queryKey: ["contacts"] });
  
          // רענון לפי ID
          const contact: Contact = await contactService.getById(result.new_contact_id);
          cacheManager.updateCache(["contacts"], contact, "id");
        }
  
        // קריאה ל-onSuccess שהועבר מהקומפוננטה
        if (options?.onSuccess) {
          options.onSuccess(result, variables, context);
        }
      },
      ...options,
    });
  };